import DataService from '../../common/services/dataService';
import HttpService from './HttpService';
import Creators from './actions';
const setEnvironmentFilter = Creators.setEnvironmentFilter;
const setMediaFilter = Creators.setMediaFilter;
const toggleCompleted = Creators.toggleCompleted;
const toggleLive = Creators.toggleLive;
const search = Creators.search;
const sortByAscendingOrder = Creators.sortByAscendingOrder;
const sortByDecendingOrder = Creators.sortByDecendingOrder;
const fetchStudiesBegin = Creators.fetchStudiesBegin;
const fetchStudiesSuccess = Creators.fetchStudiesSuccess;
const fetchStudiesError = Creators.fetchStudiesError;
const onAddNewStudyWithEnvironments = Creators.onAddNewStudy;
const closeModal = Creators.cancelOnAddNewStudy;
const cancelOnAddNewStudy = Creators.cancelOnAddNewStudy;
const submittingStudyError = Creators.submittingStudyError;
const submittingStudy = Creators.submittingStudy;
const newStudySuccessMessage = Creators.newStudySuccessMessage;
const getCode = (val) => {
  if (typeof val === 'number') {
    return val;
  }

  if (val && typeof val === 'object') {
    return val.code ?? val.id ?? null;
  }
  return null;
};
// const getcode=(val)=>{
  //typeof val=== 'number? va}

const getStudyData = (
  studiesPerPage,
  pageNum,
  orderBy,
  filterName,
  filterLive,
  filterIsCompleted,
  mediaId,
  environmentId,
  owner_id,
  filterPhaseId,
  filterPhaseColourId,
  filterPhaseColourSystemProcessingEnabled,
  filterPhaseColourSystemPausedOverride
) => {
  return async (dispatch) => {
    dispatch(fetchStudiesBegin());
    try {
      let data = {
        results_per_page: studiesPerPage,
        page_num: pageNum,
        order_by: orderBy,
        filter_name: filterName,
        filter_live: filterLive,
        filter_completed: filterIsCompleted,
        filter_media_id: mediaId,
        filter_environment_id: environmentId,
      };
      if (filterPhaseId !== -1) {
        data.filter_phase_id = filterPhaseId;
      }

      if (filterPhaseColourId !== -1) {
        data.filter_phase_colour_id = filterPhaseColourId;
      }
      if (
        filterPhaseColourSystemProcessingEnabled !== undefined &&
        filterPhaseColourSystemProcessingEnabled !== null &&
        filterPhaseColourSystemProcessingEnabled !== "-1"
      ) {
        data.filter_phase_colour_system_processing_enabled =
        filterPhaseColourSystemProcessingEnabled;
      }

      if (
        filterPhaseColourSystemPausedOverride !== undefined &&
        filterPhaseColourSystemPausedOverride !== null &&
        filterPhaseColourSystemPausedOverride !== "-1"
      ) {
        data.filter_phase_colour_system_paused_override =
        filterPhaseColourSystemPausedOverride;
      }

      if (owner_id !== null && owner_id !== undefined && owner_id !== '' && owner_id !== 'null') {
        data.user_id = Number(owner_id);
      }
      const res = await DataService.fetchAllStudyData(data);
      dispatch(fetchStudiesSuccess(res));
    } catch (err) {
      dispatch(fetchStudiesError(err));
      throw err;
    }
  };
};

const bulkToggleQualityChecks = (
  studyIds = [],
  enabled = false,
  action = "update_qualitychecks_enabled"
) => {
  return async (dispatch) => {
    try {
      const studylist = (studyIds || []).map((id) => ({
        studyid: Number(id),
        action, 
        approved: !!enabled,
      }));

      return await DataService.updateStudiesList(studylist);
    } catch (err) {
      dispatch(fetchStudiesError(err));
      throw err;
    }
  };
};

const getAllFilteredStudyIds = (
  studiesPerPage,
  orderBy,
  filterName,
  filterLive,
  filterIsCompleted,
  mediaId,
  environmentId,
  owner_id,
  filterPhaseId,
  filterPhaseColourId,
  filterPhaseColourSystemProcessingEnabled,
  filterPhaseColourSystemPausedOverride
) => {
  return async (dispatch) => {
    try {
      let data = {
        results_per_page: 100000,
        page_num: 1,
        order_by: orderBy,
        filter_name: filterName,
        filter_live: filterLive,
        filter_completed: filterIsCompleted,
        filter_media_id: mediaId,
        filter_environment_id: environmentId,
      };

      if (filterPhaseId !== -1) {
        data.filter_phase_id = filterPhaseId;
      }

      if (filterPhaseColourId !== -1) {
        data.filter_phase_colour_id = filterPhaseColourId;
      }

      if (
        filterPhaseColourSystemProcessingEnabled !== undefined &&
        filterPhaseColourSystemProcessingEnabled !== null &&
        filterPhaseColourSystemProcessingEnabled !== "-1"
      ) {
        data.filter_phase_colour_system_processing_enabled =
          filterPhaseColourSystemProcessingEnabled;
      }

      if (
        filterPhaseColourSystemPausedOverride !== undefined &&
        filterPhaseColourSystemPausedOverride !== null &&
        filterPhaseColourSystemPausedOverride !== "-1"
      ) {
        data.filter_phase_colour_system_paused_override =
          filterPhaseColourSystemPausedOverride;
      }

      if (
        owner_id !== null &&
        owner_id !== undefined &&
        owner_id !== "" &&
        owner_id !== "null"
      ) {
        data.user_id = Number(owner_id);
      }

      const res = await DataService.fetchAllStudyData(data);

      const studies =
        res?.data?.data ||
        res?.data?.studies ||
        res?.data ||
        [];

      return (studies || [])
        .map((study) => Number(study.study_id))
        .filter(Boolean);
    } catch (err) {
      dispatch(fetchStudiesError(err));
      throw err;
    }
  };
};


const sortAscendingData = (item, type) => {
  if (type === 'DECENDING') {
    return (dispatch) => {
      dispatch(sortByDecendingOrder(item, type));
    };
  } else {
    return (dispatch) => {
      dispatch(sortByAscendingOrder(item, type));
    };
  }
};
const submitOutOfHomeStudy = (values, history) => {
  const data = {
    name: values.name,
    study_type_id: 12,
    environment_id: getCode(values.environment_id),
    project_location: getCode(values.project_location),
    panel_size: values.respondents?.id === 1
      ? values.panel_size * values.number_of_cells
      : values.panel_size,
    number_of_cells: values.number_of_cells,
    stimulus_list: [],
    notes: values.notes,
    objective: values.objective,
    brief: values.brief,
    methodology: values.methodology,
    study_duration: values.study_duration,
    decision_to_inform: values.decision_to_inform,
    incentive: values.incentive,
    proposal_signoff_date: values.proposal_signoff_date,
    proposed_data_collection_start: values.proposed_data_collection_start,
    proposed_data_collection_end: values.proposed_data_collection_end,
    debrief_date: values.debrief_date,
    override_owner_id: values.override_owner_id || null,
    consultant_user_id: values.consultant_user_id || null,
  };

  const totalCells = values.number_of_cells || 1;
  let cellIndex = 1;

  if (values.cachepage_stim_list?.length > 0) {
    for (const cache of values.cachepage_stim_list) {
      for (const stim of cache.stim_list) {
        if (stim.stim_url && cellIndex <= totalCells) {
          data.stimulus_list.push({
            url: stim.stim_url,
            cell_index: cellIndex,
            step_index: 1,
          });
          cellIndex++;
        }
        if (cellIndex > totalCells) break;
      }
      if (cellIndex > totalCells) break;
    }
  }

  return submitStudy(data, history);
};

const submitGamingStudy = (values, history) => {
  const data = {
    name: values.name,
    study_type_id: 13,
    environment_id: getCode(values.environment_id),
    project_location: getCode(values.project_location),
    panel_size: values.respondents?.id === 1
      ? values.panel_size * values.number_of_cells
      : values.panel_size,
    number_of_cells: values.number_of_cells,
    stimulus_list: [],
    notes: values.notes,
    objective: values.objective,
    brief: values.brief,
    methodology: values.methodology,
    study_duration: values.study_duration,
    decision_to_inform: values.decision_to_inform,
    incentive: values.incentive,
    proposal_signoff_date: values.proposal_signoff_date,
    proposed_data_collection_start: values.proposed_data_collection_start,
    proposed_data_collection_end: values.proposed_data_collection_end,
    debrief_date: values.debrief_date,
    override_owner_id: values.override_owner_id || null,
    consultant_user_id: values.consultant_user_id || null,
  };

  const totalCells = values.number_of_cells || 1;
  let cellIndex = 1;

  if (values.cachepage_stim_list?.length > 0) {
    for (const cache of values.cachepage_stim_list) {
      for (const stim of cache.stim_list) {
        if (stim.stim_url && cellIndex <= totalCells) {
          data.stimulus_list.push({
            url: stim.stim_url,
            cell_index: cellIndex,
            step_index: 1,
          });
          cellIndex++;
        }
        if (cellIndex > totalCells) break;
      }
      if (cellIndex > totalCells) break;
    }
  }

  return submitStudy(data, history);
};

const submitDefaultStudy=( values, history) => 
  {
  const data= 
  {

    name:values.name,
    study_type_id:getCode(values.study_type_id),
    panel_size:values.panel_size,
    project_location: getCode(values.project_location),

  };

  return submitStudy( data, history);
};


const onAddNewStudySubmit = (referencedValues, history) => {
  const values = JSON.parse(JSON.stringify(referencedValues));
  const studyTypeId = getCode(values.study_type_id);

  if (studyTypeId == null || isNaN(studyTypeId)) {
    throw new Error("Study type is required");
  }

  switch (studyTypeId) {
    case 4: return submitFocusProject(values, history);
    case 5: return submitSocialMediaStudy(values, history);
    case 7: return submitDigitalRichMedia(values, history);
    case 8: return submitDigitalAdTest(values, history);
    case 10: return submitVastAdTest(values, history);
    case 12: return submitOutOfHomeStudy(values, history);
    case 13: return submitGamingStudy(values, history);
    case 14: return submitCustomStudy(values, history);
    default: return submitDefaultStudy(values, history); 
  }
};


const onAddNewStudy = () => {
  return async (dispatch) => {
    const results = await HttpService.getEnvironmentList();
    const mediaResults = await HttpService.getMediaList();
    const studyTypesResults = await HttpService.getStudyTypesList();
    const languageResults = await HttpService.getLanguageList();
    const questionResults = await HttpService.getQuestionsList();
    const locationResults = await HttpService.getLocationsList();
    const brandResults = await HttpService.getBrandTypes();
    const AdTypesResults = await HttpService.getAdTypes();
    const InContextResults = await HttpService.getInContextTypes();
    const PanelsList = await HttpService.getPanelsList();
    const CompaniesList = await HttpService.getCompaniesList();
    const PanelistRoles = await HttpService.getPanelistRoles();
    const CompanyUsers = await HttpService.getCompanyUserList();
    
    dispatch(
      onAddNewStudyWithEnvironments(
        results,
        mediaResults,
        studyTypesResults,
        languageResults,
        questionResults,
        locationResults,
        brandResults,
        AdTypesResults,
        InContextResults,
        PanelsList,
        PanelistRoles,
        CompanyUsers.data.data,
        CompaniesList,
        
      )
    );
  };
};


const submitFocusProject = (values, history) => {
  const data = {
    name: values.name,
    study_type_id: 4,
    environment_id: getCode(values.environment_id),
    panel_size: values.panel_size,
    project_location: getCode(values.project_location),
    language: typeof values.language === 'object' ? values.language.code : values.language,
    quick_step_list: values.quick_step_list,
    quick_task_data: 
    {
      ...values.quick_task_data,
      panelist_role: typeof values.quick_task_data.panelist_role === 'object'
      ? values.quick_task_data.panelist_role.code 
      : values.quick_task_data.panelist_role,

    panel_id: typeof values.quick_task_data.panel_id === 'object'
      ? values.quick_task_data.panel_id.id         
      : values.quick_task_data.panel_id,
      }  ,
      override_owner_id: values.override_owner_id || null,
      consultant_user_id: values.consultant_user_id || null,
};

  return submitStudy(data, history);
};


const submitSocialMediaStudy = (values, history) => {
  const base = {
    name: values.name,
    study_type_id: 5,
    environment_id: getCode(values.environment_id),
    panel_size: values.panel_size,
    project_location: getCode(values.project_location),
    language: typeof values.language === "object" ? values.language.code : values.language,
    incontext_site: values.incontext_site.code,
    ad_type: values.ad_type,
    extra_time_on_feed_s: values.extra_time_on_feed_s,
    stim_url: values.stim_url,
    brand_id: typeof values.brand_id === "object" ? values.brand_id.id : values.brand_id,
    override_owner_id: values.override_owner_id || null,
    consultant_user_id: values.consultant_user_id || null,
  };

  switch (base.incontext_site) {
    case "tt":
      return submitTikTokStudy(values, base, history);
    case "in":
    case "rin":
      return submitInstagramStudy(values, base, history);
    case "fb":
    case "rfb":
      return submitFacebookStudy(values, base, history);
    case "sc":
    case "rsc":
      return submitSnapchatStudy(values, base, history);
    case "tw":
      return submitTwitterStudy(values, base, history);
    case "vk":
      return submitVKStudy(values, base, history);
    case "pin":
      return submitPinterestStudy(values, base, history);
    case "yt":
      return submitYouTubeStudy(values, base, history);
    default:
      throw new Error("Unsupported incontext_site: " + base.incontext_site);
  }
};


const submitTikTokStudy = (values, base, history) => {
  const data = {
    ...base,
    tt_profile_src: values.tt_profile_src,
    tt_profile_name: values.tt_profile_name,
    tt_desc: values.tt_desc,
    tt_song_name: values.tt_song_name,
    tt_promo_text: values.tt_promo_text,
    tt_promo_button: values.tt_promo_button,
    tt_comments: values.tt_comments,
  };
  return submitStudy(data, history);
};

const submitInstagramStudy = (values, base, history) => {
  const data = {
    ...base,
    in_profile_src: values.in_profile_src,
    in_channel_name: values.in_channel_name,
    in_call_to_action: values.in_call_to_action,
    in_description: values.in_description,
    in_promoted_button_text: values.in_promoted_button_text,
  };
  return submitStudy(data, history);
};
const submitFacebookStudy = (values, base, history) => {
  const data = {
    ...base,
    fb_profile_src: values.fb_profile_src,
    fb_channel_name: values.fb_channel_name,
    fb_description: values.fb_description,
    fb_promoted: values.fb_promoted,
    fb_promoted_description: values.fb_promoted_description,
    fb_promoted_description2: values.fb_promoted_description2,
    fb_promoted_domain: values.fb_promoted_domain,
    fb_promoted_button_text: values.fb_promoted_button_text,
    fb_call_to_action: values.fb_call_to_action,
    has_sound: values.has_sound,
  };
  return submitStudy(data, history);
};
const submitSnapchatStudy = (values, base, history) => {
  const data = {
    ...base,
    sc_channel_name: values.sc_channel_name,
    sc_description: values.sc_description,
    sc_profile_src: values.sc_profile_src,
    sc_cta: values.sc_cta,
    sc_promo_text: values.sc_promo_text,
    sc_promo_desc: values.sc_promo_desc,
    sc_promo_top: values.sc_promo_top,
    sc_promo_rating: values.sc_promo_rating,
  };
  return submitStudy(data, history);
};
const submitTwitterStudy = (values, base, history) => {
  const data = {
    ...base,
    tw_channel_name: values.tw_channel_name,
    tw_profile_src: values.tw_profile_src,
    tw_description: values.tw_description,
    tw_promoted: values.tw_promoted,
    tw_promoted_description: values.tw_promoted_description,
    tw_promoted_domain: values.tw_promoted_domain,
  };
  return submitStudy(data, history);
};
const submitVKStudy = (values, base, history) => {
  const data = {
    ...base,
    fb_profile_src: values.fb_profile_src,
    fb_channel_name: values.fb_channel_name,
    fb_description: values.fb_description,
    fb_promoted_description: values.fb_promoted_description,
    fb_promoted_description2: values.fb_promoted_description2,
    fb_promoted_domain: values.fb_promoted_domain,
    fb_promoted_button_text: values.fb_promoted_button_text,
  };
  return submitStudy(data, history);
};
const submitPinterestStudy = (values, base, history) => {
  const data = {
    ...base,
    pn_stim_title: values.pn_stim_title,
    pn_profile_src: values.pn_profile_src,
    pn_stim_profile: values.pn_stim_profile,
    pn_type: values.pn_type,
  };
  return submitStudy(data, history);
};

const submitYouTubeStudy = (values, base, history) => {
  const data = {
    ...base,
    yt_skippable: values.yt_skippable,
    yt_skip_time_s: values.yt_skip_time_s,
    yt_video_type: values.yt_video_type,
  };

  return submitStudy(data, history);
};

const submitDigitalRichMedia = (values, history) => {
  const data = {
    name: values.name,
    study_type_id: 7,
    environment_id: getCode(values.environment_id),
    panel_size: values.panel_size,
    project_location: getCode(values.project_location),
    language: typeof values.language === 'object' ? values.language.code : values.language,
    incontext_primary_site: values.incontext_primary_site,
    incontext_distraction_site: values.incontext_distraction_site,
    stim_script: values.stim_script,
    brand_id: typeof values.brand_id === 'object' ? values.brand_id.id : values.brand_id,
    override_owner_id: values.override_owner_id || null,
    consultant_user_id: values.consultant_user_id || null,
  };

  return submitStudy(data, history);
};

const submitDigitalAdTest = (values, history) => {
  const cleanedCachepageStimList = values.cachepage_stim_list?.map((cache, i) => ({
    ...cache,
    cell_index: i + 1,
    stim_list: cache.stim_list.map((stim) => ({
      ...stim,
      brand_id: typeof stim.brand_id === 'object' && stim.brand_id !== null
        ? stim.brand_id.id
        : stim.brand_id,
      ad_type_id: typeof stim.ad_type_id === 'object' && stim.ad_type_id !== null
        ? stim.ad_type_id.id
        : stim.ad_type_id,
    })),
  }));

  const data = {
    name: values.name,
    study_type_id: 8,
    environment_id: getCode(values.environment_id),
    panel_size: getCode(values.panel_size),
    project_location: getCode(values.project_location),
    language: typeof values.language === 'object' ? values.language.code : values.language,
    incontext_distraction_site: values.incontext_distraction_site,
    stim_script: values.stim_script,
    brand_id: typeof values.brand_id === 'object' ? values.brand_id.id : values.brand_id,
    cell_list: values.cell_list,
    cachepage_stim_list: cleanedCachepageStimList,
    override_owner_id: values.override_owner_id || null,
    consultant_user_id: values.consultant_user_id || null,
    

  };

  return submitStudy(data, history);
};


const submitVastAdTest = (values, history) => {
  const data = {
    name: values.name,
    study_type_id: 10,
    environment_id: getCode(values.environment_id),
    number_of_cells: values.number_of_cells,

    panel_code: values.panel_code,
    panel_success: values.panel_success,
    panel_screen: values.panel_screen,
    panel_quotafull: values.panel_quotafull,
    panel_insert_param: values.panel_insert_param,
    panel_seconds_before_move_next: values.panel_seconds_before_move_next,

    embedded_page_list: values.embedded_page_list,

    override_owner_id: values.override_owner_id || null,
    consultant_user_id: values.consultant_user_id || null,
  };

  return submitStudy(data, history);
};

const submitCustomStudy = (values, history) => {
  const data = {
    name: values.name,
    study_type_id: 14,
    environment_id: getCode(values.environment_id),
    media_id: getCode(values.media_id),
    number_of_cells: values.number_of_cells,
    panel_size: values.panel_size,
    project_location: getCode(values.project_location),
    language: typeof values.language === 'object' ? values.language.code : values.language,
    notes: values.notes,
    override_owner_id: values.override_owner_id || null,
    consultant_user_id: values.consultant_user_id || null,
  };

  return submitStudy(data, history);
};

const submitStudy = (data, history) => {
  return async (dispatch) => {
    try {
      dispatch(submittingStudy(true));
      const res = await DataService.onAddNewStudySubmit(data);
      const studyId = res.data.study_id;

      if (res.data.success) {
        await dispatch(newStudySuccessMessage(res.data));
        history.push(`/my_studies/overview/${studyId}/thank_you`);
      } else {
        dispatch(submittingStudyError(res.data));
      }
    } catch (err) {
      dispatch(submittingStudyError(true));
    } finally {
      dispatch(submittingStudy(false));
    }
  };
};

export default {
  sortAscendingData,
  getStudyData,
  bulkToggleQualityChecks,
  setEnvironmentFilter,
  setMediaFilter,
  toggleCompleted,
  toggleLive,
  search,
  sortByAscendingOrder,
  sortByDecendingOrder,
  fetchStudiesBegin,
  fetchStudiesSuccess,
  fetchStudiesError,
  onAddNewStudy,
  cancelOnAddNewStudy,
  onAddNewStudySubmit,
  closeModal,
  submittingStudyError,
  newStudySuccessMessage,
  getAllFilteredStudyIds,
};
